import {useSelector} from 'react-redux';

export default function useRole() {
  const authenticationState = useSelector((state: any) => state.authentication);
  return authenticationState.user.roles[0].role;
}
